/* Messe-Shop24 – Voraussichtliche Lieferung pro Variante (Metafeld custom.versandzeitvariante)
   Herkunft: Inline-Skript in layout/theme.liquid (Canopy 6.3.1 live, „Lieferzeiten Update“).
   Rechenlogik (Werktage, Feiertage, Bestellschluss) 1:1 übernommen 2026-10-04.

   Änderung gegenüber 6.3.1: Web-Component statt globalem Listener auf [name='id'].
   Canopy 7 rendert den Preisblock bei jedem Variantenwechsel neu; <ms-lieferzeit> rechnet beim
   Einfügen ins DOM (connectedCallback) automatisch für die neue Variante.
   Markup: snippets/ms-pdp-lieferzeit.liquid
   Eigene Datei: wird von Canopy-Updates nicht überschrieben. */
(function () {
  if (customElements.get('ms-lieferzeit')) return;

  /* ---------- Konfiguration ---------- */
  var CUTOFF_STUNDE       = 14;   // Bestellungen ab dieser Uhrzeit zaehlen ab dem naechsten Werktag
  var REFORMATIONSTAG     = true; // 31.10. ist in HH/SH gesetzlicher Feiertag
  var HEILIGABEND_FREI    = true; // 24.12. und 31.12. als Nicht-Werktage behandeln
  var EXTRA_SCHLIESSTAGE  = [];   // Betriebsferien, Format: ["2026-12-28", "2026-12-29"]
  var MAX_PLAUSIBEL       = 90;   // groessere Werte gelten als Datenfehler -> Rohtext-Fallback

  var WOCHENTAGE = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];


  /* ---------- Feiertage ---------- */
  function zwei(n) { return (n < 10 ? "0" : "") + n; }
  function iso(d)  { return d.getFullYear() + "-" + zwei(d.getMonth() + 1) + "-" + zwei(d.getDate()); }

  /* Ostersonntag nach Gauss/Lichtenberg */
  function ostersonntag(jahr) {
    var a = jahr % 19,
        b = Math.floor(jahr / 100),
        c = jahr % 100,
        d = Math.floor(b / 4),
        e = b % 4,
        f = Math.floor((b + 8) / 25),
        g = Math.floor((b - f + 1) / 3),
        h = (19 * a + b - d - g + 15) % 30,
        i = Math.floor(c / 4),
        k = c % 4,
        l = (32 + 2 * e + 2 * i - h - k) % 7,
        m = Math.floor((a + 11 * h + 22 * l) / 451),
        monat = Math.floor((h + l - 7 * m + 114) / 31),
        tag   = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(jahr, monat - 1, tag);
  }

  var feiertagCache = {};
  function feiertage(jahr) {
    if (feiertagCache[jahr]) return feiertagCache[jahr];
    var ostern = ostersonntag(jahr), set = {};
    function relativ(tage) {
      var x = new Date(ostern.getFullYear(), ostern.getMonth(), ostern.getDate() + tage);
      return iso(x);
    }
    [
      jahr + "-01-01",  // Neujahr
      relativ(-2),      // Karfreitag
      relativ(1),       // Ostermontag
      jahr + "-05-01",  // Tag der Arbeit
      relativ(39),      // Christi Himmelfahrt
      relativ(50),      // Pfingstmontag
      jahr + "-10-03",  // Tag der Deutschen Einheit
      jahr + "-12-25",  // 1. Weihnachtstag
      jahr + "-12-26"   // 2. Weihnachtstag
    ].forEach(function (t) { set[t] = true; });

    if (REFORMATIONSTAG)  set[jahr + "-10-31"] = true;
    if (HEILIGABEND_FREI) { set[jahr + "-12-24"] = true; set[jahr + "-12-31"] = true; }
    EXTRA_SCHLIESSTAGE.forEach(function (t) { set[t] = true; });

    feiertagCache[jahr] = set;
    return set;
  }

  function istWerktag(d) {
    var wt = d.getDay();
    if (wt === 0 || wt === 6) return false;
    return !feiertage(d.getFullYear())[iso(d)];
  }

  function plusWerktage(start, anzahl) {
    var d = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    var rest = anzahl;
    while (rest > 0) {
      d.setDate(d.getDate() + 1);
      if (istWerktag(d)) rest--;
    }
    return d;
  }

  /* ---------- Metafeld-Wert parsen ---------- */
  /* Verarbeitet "3-5", "5 - 8", "13 - 15 ", "5 -10", "2-4 Werktag",
     "ab 15.12.2025 lieferbar!  3-5" und Einzelwerte wie "20". */
  function parseWerktage(rohwert) {
    var text = String(rohwert == null ? "" : rohwert).trim();
    if (!text) return null;

    var min, max;
    var spanne = text.match(/(\d{1,3})\s*(?:-|–|—|bis)\s*(\d{1,3})/i);
    if (spanne) {
      min = parseInt(spanne[1], 10);
      max = parseInt(spanne[2], 10);
    } else {
      var einzel = text.match(/\d{1,3}/);
      if (!einzel) return null;
      min = max = parseInt(einzel[0], 10);
    }
    if (min > max) { var tmp = min; min = max; max = tmp; }
    if (!(min >= 1) || max > MAX_PLAUSIBEL) return null;
    return { min: min, max: max };
  }

  /* ---------- Ausgabe ---------- */
  function formatiere(d, mitJahr) {
    return WOCHENTAGE[d.getDay()] + ", " + zwei(d.getDate()) + "." + zwei(d.getMonth() + 1) + "."
         + (mitJahr ? d.getFullYear() : "");
  }

  /* Bearbeitungsstart: heute, sofern Werktag und vor Bestellschluss – sonst der naechste Werktag */
  function zaehlStart() {
    var jetzt = new Date();
    var heute = new Date(jetzt.getFullYear(), jetzt.getMonth(), jetzt.getDate());
    if (jetzt.getHours() >= CUTOFF_STUNDE || !istWerktag(heute)) {
      return plusWerktage(heute, 1);
    }
    return heute;
  }

  class MsLieferzeit extends HTMLElement {
    connectedCallback() {
      var tageEl = this.querySelector('[data-ms-lieferzeit-tage]');
      if (!tageEl) return;
      var rohwert  = this.dataset.versandzeit;
      var werktage = parseWerktage(rohwert);

      /* Kein Wert -> ausgeblendet lassen. Unlesbarer Wert -> Rohtext als Fallback. */
      if (!werktage) {
        var text = String(rohwert == null ? "" : rohwert).trim();
        if (text === "") { this.hidden = true; return; }
        tageEl.textContent = /\d/.test(text) ? text + " Werktage" : text;
        this.hidden = false;
        return;
      }

      var start = zaehlStart();
      var von   = plusWerktage(start, werktage.min);
      var bis   = plusWerktage(start, werktage.max);

      var aktuellesJahr = new Date().getFullYear();
      var mitJahr = (von.getFullYear() !== aktuellesJahr) || (bis.getFullYear() !== aktuellesJahr);

      tageEl.textContent = (werktage.min === werktage.max)
        ? formatiere(bis, mitJahr)
        : formatiere(von, mitJahr) + " – " + formatiere(bis, mitJahr);

      this.setAttribute("title", (werktage.min === werktage.max)
        ? werktage.max + " Werktage"
        : werktage.min + "–" + werktage.max + " Werktage");

      this.hidden = false;
    }
  }

  customElements.define('ms-lieferzeit', MsLieferzeit);
})();
